module.exports = __webpack_public_path__ + "img/cooperation4.eb2c2891.png";